import { Component, OnInit,ErrorHandler } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
//import { ErrorHandler } from '../../../shared/ErrorHandler';
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';


@Component({
  selector: 'app-pigmy-creation',
  templateUrl: './pigmy-creation.component.html',
  styleUrls: ['./pigmy-creation.component.css']
})
export class PigmyCreationComponent implements OnInit {
  title = "Pigmy Account Creation";
  CustomerList  : any = []; 
  data : any = {};
  p : any = {};
  Schemeslist : any = [];
  myDate = new Date();
  DateValues : string;
  DateValues1 : string;
  AgentsList : any = [];
  RelationList : any = [];
  n : any = {};
  nomineelist : any = [];
  custId : any ;
  agentId : any ;
  glsubId : any;
  AccountNumber : string ;
  ACC_ID : number ;
  mode : string;
  today = new Date();  
branchidlog:any;
  schdata: any;
  display: string;

  schemetypelist  : any = []; 
  stl:any={};
  glsub_id_all: any;
  suspnsdata: any;
  nominepercentage:number;
  prmval: any;
  pigmyaccountschmwise:boolean=false;

  gotacc_no:any;
  CustomerDetails: any;


  constructor(private userService: UserService,private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private datepipe: DatePipe  ) { }

  ngOnInit() {
    this.DateValues = this.datepipe.transform(this.myDate, 'yyyy-MM-dd'); 
    this.branchidlog=localStorage.getItem('BRANCH_ID');
    this.GetRequiredData(this.branchidlog);

    this.route.params.subscribe(params => {
      this.mode = params['mode'];
      this.ACC_ID = params['ACCId'];     
      this.GetPigmyAgentById(this.ACC_ID); 
      debugger;    
      this.p.Open_DT==this.getdatefun(this.today);
      
      
    });
  }
  GetCustomerDetailsbyname(SearchValue: any, SearchName: any) {    
    debugger;
    let BRANCH_ID=this.branchidlog;
     if (SearchValue == "" && SearchName == "") {
         this.CustomerDetails = null;
         return
     }
     if (SearchValue == "" || SearchValue == undefined) { SearchValue = "empty" } 
     if (SearchName == "" || SearchName == undefined) { SearchName = "empty" }
     this.userService.GetCustomerDetails(SearchValue, SearchName,BRANCH_ID)
         .subscribe(
             (data: any) => {
                 this.CustomerDetails = data;
                 this.CustomerList=data;
                 // this.p.AGENT_add=data.
                 console.log(data);
             }, (error) => {
                 this.errorHandler.handleError(error);
             });
 }
  updatematdate(PERIOD:number,opdt:Date)
  {
   this.data = this.userService.getMaturityDateForPigmyCreation(opdt,PERIOD);
   this.data.subscribe(
        (response: any) => {  
          debugger;
          console.log(response);
          if(response!=null)
                this.p.LAST_INTDT=((response).split('T'))[0];
         //let a=((this.p.LAST_INTDT).split(' '))[0];
         //console.log(a);
       }
       ) 
  }

  GetPigmyAgentById(ACC_ID){
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAgentById(ACC_ID);
    this.data.subscribe(
      (response: any) => {
        console.log('response');
        console.log(response)
        this.p = response;
        this.gotacc_no=response.ACC_NO;

        this.getagentforview(response.branchid,response.GLSUB_ID);
        this.ChangeAgentforview(response.branchid)

        if(response.NomineeAdd.length >0 )
        this.nomineelist = response.NomineeAdd;
        if (this.p.Open_DT != null)
        this.p.Open_DT = ((this.p.Open_DT).split('T'))[0];
        if (this.p.LAST_INTDT != null)
        this.p.LAST_INTDT = ((this.p.LAST_INTDT).split('T'))[0];
        document.getElementById('loader-spinner').style.display = "none";
        
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  
  getagentforview(branchid,glsub)
  {
    this.data = this.userService.GetAgentsforaccount(branchid,glsub);
    this.data.subscribe(
         (response: any) => {         
          this.AgentsList= response;        
  }
  )
} 
ChangeAgentforview(AgentId)
{
  debugger;
  for(let i=0;i<this.AgentsList.length;i++)
  {
    if(AgentId==this.AgentsList[i].AGENT_ID)
    {
      this.prmval=this.AgentsList[i].PRM_VAL;
      this.pigmyaccountschmwise=this.AgentsList[i].pigmyacschmwise;
    }
  }
  this.agentId = AgentId;
  this.suspnsdata=this.userService.getsuspsnamt(AgentId);
  this.suspnsdata.subscribe(
    (susresponse:any)=>
    {
      this.p.suspenseamount=susresponse;
      console.log("suspenseamount");
      console.log(susresponse);
    }
  ) 
}
  GetRequiredData(branchid){
  //   this.data = this.userService.GetAllCustomerIds();
  //   this.data.subscribe(
  //        (response: any) => {         
  //         this.CustomerList= response;  
  // }
  // ) 

  this.data = this.userService.GetAllSchemes(branchid);
  this.data.subscribe(
       (response: any) => {         
        this.Schemeslist= response;  
        console.log(this.Schemeslist);   
}
) 


//GetAllRelations
this.data = this.userService.GetAllRelations();
  this.data.subscribe(
       (response: any) => {         
        this.RelationList= response;   
        console.log(this.RelationList); 
}
) 
}

  GetCustomerRelatedData(CustomerId){
    this.custId = CustomerId;
    var list = this.CustomerList.filter(a => a.CUSTID == CustomerId);   
    this.p.CUSNAME = list[0].CUSNAME;
    this.p.GNAME_LL = list[0].GNAME_LL;
    
  }

  AddNominee(n) {
    let bool = 0; 
    
    let bengen=null;
    // if (p.CasePeti_PetitionerName == "" || p.CasePeti_Respondent == "") { bool = 1 }
    // if ((p.CasePeti_PetitionerName != null || p.CasePeti_PetitionerName != undefined) || (p.CasePeti_Respondent != null || p.CasePeti_Respondent != undefined) 
    //  && bool == 0) {
      if(n.Gender=="M")
        bengen=1;
      else
         bengen=2;
  
      let temp = {
        BEN_NAME: n.BEN_NAME,
        BEN_REL: n.BEN_REL,
        BEN_GENDER : bengen,
        BEN_AGE : n.BEN_AGE,
        BEN_NomineePerc : n.BEN_NomineePerc     
      }
      debugger;
      if(this.nominepercentage==undefined||null)
      this.nominepercentage=0;
     // this.nominepercentage=(+this.nominepercentage)+(+n.BEN_NomineePerc);
      if(((+this.nominepercentage)+(+n.BEN_NomineePerc))>100)
      {
        swal('Warning','Nomination Percentage cannot be greater than 100%','warning')
      }
      else
      {
        this.nominepercentage=(+this.nominepercentage)+(+n.BEN_NomineePerc);
      this.nomineelist.push(temp);
      this.n = {};
      }
    }

    ClearNominee()
    {
    this.n = {};
  }
  
  //delete row

  // Detailsremove(i){      
  //   this.nomineelist.splice(i, 1);      
  // }

  Detailsremove(i){     
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.nomineelist.splice(i, 1); 
      }
    })     
  } 
 
   
  

  GetCustomerDetails(CustId){
    this.CUSTIDempty=false;
    this.data = this.userService.GetAllCustomerIdDetailsforSpeedSearch(CustId);
    this.data.subscribe(
         (response: any) => {         
          this.CustomerList= response;  
          console.log('Speed search');
          console.log(this.CustomerList);
  })

  }

  GetCustomerDetailsById(CustId,CusName){
    this.custId = CustId;
    this.p.CUSTID = CustId;
    var list = this.CustomerList.filter(a => a.CUSTID == CustId);   
    this.p.CUSNAME = CusName;
    this.p.GNAME_LL = list[0].GNAME_LL;
    this.GetCustomerDetails(null);
    
  }
  getdatefun(indt:any)
  {
    this.DateValues1=this.datepipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues1;
 }
 setdateonper(PERIOD:number,opdt:Date)
 {
   debugger;

   var dtdate;
   var date1;

  dtdate=new Date(this.today.setMonth(this.today.getMonth() + PERIOD));
  // dtdate= this.today.setMonth( this.today.getMonth()-1 + PERIOD);//this.today.setDate() getMonth()+PERIOD;
  this.p.LAST_INTDT=this.getdatefun(dtdate);
 }

 GetSchemeRelatedData(GLSUB_ID)
 {
  this.GLSUB_IDempty=false;
   this.glsub_id_all=GLSUB_ID;
   this.getagent(this.branchidlog);
   this.schdata=this.userService.getpigmySchemeType(GLSUB_ID,this.branchidlog);
   this.schdata.subscribe(
     (schmelistResponse:any)=>{
       debugger;
     
     // this.openModalDialog();
      this.schemetypelist=schmelistResponse;
      console.log(this.schemetypelist);
      this.p.PERIOD_M_DISP = this.schemetypelist[0].PERIOD_M_FR;
      this.p.AGREED_AMT = this.schemetypelist[0].AGREED_AMT;
      this.p.Open_DT = this.DateValues;
      this.p.INT_RATE = this.schemetypelist[0].INT_RATE;
   
      //Maturity Date
     this.data = this.userService.getMaturityDateForPigmyCreation(this.p.Open_DT,this.p.PERIOD_M_DISP);
     this.data.subscribe(
          (response: any) => {  
            debugger;
            console.log(response);
            if(response!=null)
                  this.p.LAST_INTDT=((response).split('T'))[0];
           //let a=((this.p.LAST_INTDT).split(' '))[0];
           //console.log(a);
         }
         )   
     }
   )

 }
 openModalDialog(){
  this.display='block'; //Set block css
}

closeModalDialog(){
this.display='none'; //set none css after close dialog
}

setschemetypelist(schtype)
{
  this.closeModalDialog();
  debugger;
  console.log("schtype");
  console.log(schtype);
     this.p.PERIOD_M_DISP = schtype.PERIOD_M_TO;
   this.p.AGREED_AMT = schtype.AGREED_AMT;
   this.p.Open_DT = this.DateValues;
   this.p.INT_RATE = schtype.INT_RATE;

   //Maturity Date
  this.data = this.userService.getMaturityDateForPigmyCreation(this.p.Open_DT,this.p.PERIOD_M_DISP);
  this.data.subscribe(
       (response: any) => {  
         if(response!=null)
        this.p.LAST_INTDT=((response).split('T'))[0];
        //let a=((this.p.LAST_INTDT).split(' '))[0];
        //console.log(a);
      }
      )   
}

getagent(branchid)
{
  this.data = this.userService.GetAgentsforaccount(branchid,this.glsub_id_all);
  this.data.subscribe(
       (response: any) => {         
        this.AgentsList= response;        
}
) 
}

ChangeAgent(AgentId)
{
  this.AGENT_IDempty=false;
  for(let i=0;i<this.AgentsList.length;i++)
  {
    if(AgentId==this.AgentsList[i].AGENT_ID)
    {
      this.prmval=this.AgentsList[i].PRM_VAL;
      this.pigmyaccountschmwise=this.AgentsList[i].pigmyacschmwise;
    }
  }
  this.agentId = AgentId;
  this.suspnsdata=this.userService.getsuspsnamt(AgentId);
  this.suspnsdata.subscribe(
    (susresponse:any)=>
    {
      this.p.suspenseamount=susresponse;
      console.log("suspenseamount");
      console.log(susresponse);
    }
  )
  // console.log(AgentId);
  
  // console.log(this.custId);
  // console.log(this.glsub_id_all);
  // console.log(this.agentId);   
  //this.data = this.userService.GetAutogenerationAccontNumber(this.custId,this.agentId,this.glsubId,'');
  // this.data = this.userService.GetAutogenerationAccontNumber(this.custId,this.agentId,this.glsub_id_all,''); 
  // this.data.subscribe(
  //    (response: any) => {        
  //    this.AccountNumber = response;
  //    console.log('ACC_NO');
  //    console.log(this.AccountNumber);
  //    this.p.ACC_NO = this.AccountNumber;
  // })
  
}
setrelation(code:number)
{
  debugger;
  for(let i=0;i<=this.RelationList.length;i++)
  {
    if(code==this.RelationList[i].CODE)
    {
      this.n.Gender=this.RelationList[i].GENDER;
      return;
    }
  }

}

GLSUB_IDfilled()
{
  this.GLSUB_IDempty=false;
}
AGENT_IDfilled()
{
  this.AGENT_IDempty=false;
}
CUSTIDfilled()
{
  this.CUSTIDempty=false;
}

GLSUB_IDempty:boolean=false;
AGENT_IDempty:boolean=false;
CUSTIDempty:boolean=false;

SavePigmyCreation(PigmyCreation : NgForm)
{  
  if(PigmyCreation.value.GLSUB_ID==undefined || PigmyCreation.value.AGENT_ID==undefined || PigmyCreation.value.CUSTID==undefined)
  {

  
  if(PigmyCreation.value.GLSUB_ID==undefined)
    this.GLSUB_IDempty=true;
  if(PigmyCreation.value.AGENT_ID==undefined)
    this.AGENT_IDempty=true;
  if(PigmyCreation.value.CUSTID==undefined)
    this.CUSTIDempty=true;
  swal('Mandatory','Please fill all the mandatory fields','warning');
  }
  else
  {
  PigmyCreation.value.PRM_VAL=this.prmval;
  PigmyCreation.value.schmewise=this.pigmyaccountschmwise;
  PigmyCreation.value.branchid=this.branchidlog;
  PigmyCreation.value.NomineeAdd =  this.nomineelist;
  document.getElementById('loader-spinner').style.display = "block";
  console.log(PigmyCreation.value);
  this.data = this.userService.createApplication_Mast(PigmyCreation.value);
  this.data.subscribe(
  (response: any) => {    
    console.log("number account");
    console.log(response);    
    document.getElementById('loader-spinner').style.display = "none";
    swal('Success!', ' Pigmy Account created successfully. Account number:'+response, 'success');
    PigmyCreation.reset() ;   
    this.router.navigate(['/home/PigmyCreation']) ;        
  }, (error) => {
    document.getElementById('loader-spinner').style.display = "none";
    swal('Warning!', 'Something went wrong', 'warning');
  });
}
  
}

}



// WEBPACK FOOTER //
// ./src/app/master-account/pigmy-creation/pigmy-creation.component.ts